module.exports = __webpack_public_path__ + "img/800-fdcef4.png";